import {ConnectedRouter} from 'connected-react-router';
import React from 'react';
import {Route, Switch} from 'react-router';

import {SingleResultVoting} from 'features/election-single';
import {ChangePassword, Login, Logout, Welcome} from '../features/auth';
import {
  About,
  Election,
  Help,
  Home,
  NotFound,
  ReceiptConsult,
  ResultVoting,
  SetLocale,
  Unavailable,
} from '../features/election';
import {getPath} from './helpers';
import history from './history';
import PrivateRoute from './PrivateRoute';

const Routes: React.FC = () => (
  <ConnectedRouter history={history}>
    <>
      <Switch>
        <Route exact={true} path={getPath('welcome')} component={Welcome} />
        <Route path={getPath('auth')} component={Login} />
        <Route
          path={getPath('consultarComprovante')}
          component={ReceiptConsult}
        />
        <Route
          path={getPath('urlConsultarComprovante', ':receiptCode')}
          component={ReceiptConsult}
        />
        <PrivateRoute
          path={getPath('changePassword')}
          component={ChangePassword}
        />
        <PrivateRoute
          path={getPath('election', ':electionId')}
          component={Election}
        />
        <PrivateRoute path={getPath('resultVotes')} component={ResultVoting} />
        <PrivateRoute
          path={getPath('singleResultVotes')}
          component={SingleResultVoting}
        />
        <PrivateRoute path={getPath('help')} component={Help} />
        <PrivateRoute path={getPath('about')} component={About} />
        <PrivateRoute path={getPath('home')} component={Home} />
        <PrivateRoute path={getPath('logout')} component={Logout} />
        <Route path={getPath('setLocalePt')} component={SetLocale} />
        <Route path={getPath('setLocaleEs')} component={SetLocale} />
        <Route path={getPath('setLocaleEn')} component={SetLocale} />
        <Route path={getPath('notFound')} component={NotFound} />
        <Route path={getPath('unavailable')} component={Unavailable} />

        <Route component={NotFound} />
      </Switch>
    </>
  </ConnectedRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Routes.tsx